// // SSL Configuration
// export const SERVER_URL = 'https://10.22.197.135:5001/api';
// export const WS_URL = 'wss://10.22.197.135:5001';

export const SERVER_URL = 'https://vc.spectraai.in/vc/api';
export const WS_URL = 'wss://vc.spectraai.in';
